import React from "react";

const PALETTE = ["#D4AF37", "#3B82F6", "#EF4444", "#22C55E", "#A855F7", "#F97316", "#14B8A6", "#EC4899"];

function colorFor(name = "") {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return PALETTE[Math.abs(h) % PALETTE.length];
}

export default function TeamCrest({ name, short, logo, size = 48 }) {
  if (logo) {
    return <img src={logo} alt={name} className="object-contain rounded-full bg-ink-900" style={{ width: size, height: size }} />;
  }
  const bg = colorFor(name);
  const label = (short || name || "?").slice(0, 3).toUpperCase();
  return (
    <div
      className="grid place-items-center rounded-full font-heading font-bold text-white shrink-0"
      style={{ width: size, height: size, background: `linear-gradient(135deg, ${bg}, ${bg}99)`, fontSize: size * 0.3, border: "2px solid rgba(255,255,255,0.1)" }}
      title={name}
    >
      {label}
    </div>
  );
}
